var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseFullscreenDialog',{attrs:{"title":"Доступ для врача","full-width":"","fixed-toolbar":""},model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}},[_c('MedcardShare',{ref:"medcardShare",on:{"scanned":_vm.handleScanned}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }